import { defineMessages } from 'react-intl';

const scope = 'manualGradeConfiguration';

export default defineMessages({
  defaultError: {
    id: `${scope}.error.default`,
    defaultMessage: 'An unknown error occurred',
  },
});
